import request from '../../../core/wrappers/axios-wrapper';
import { ApiURL } from '../../../types/constants/apiUrls/api-urls';
import { RequestType } from '../../../types/enums/request-enums';

const GetStoreShippingCompanyMappings = (params: any) =>
    request({
        url: ApiURL.Query.GetStoreShippingCompanyMappings,
        method: RequestType.GET,
        params: params,
    });

const GetCargoStoreShippingCompanyMapping = (params: { countryId: number }) =>
    request({
        url: ApiURL.Query.GetCargoStoreShippingCompanyMapping,
        method: RequestType.GET,
        params: params,
    });

const GetBlockedShippingCompanyForCustomerHistory = (params: { customerId: number }) =>
    request({
        url: ApiURL.Query.GetBlockedShippingCompanyForCustomerHistory,
        method: RequestType.GET,
        params: params,
    });

const GetCustomerShippingCompanyChangeHistory = (params: { customerId: number }) =>
    request({
        url: ApiURL.Query.GetCustomerShippingCompanyChangeHistory,
        method: RequestType.GET,
        params: params,
    });

const DeliveryQuery = {
    GetStoreShippingCompanyMappings,
    GetCargoStoreShippingCompanyMapping,
    GetBlockedShippingCompanyForCustomerHistory,
    GetCustomerShippingCompanyChangeHistory,
};

export default DeliveryQuery;
